import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
  IsArray,
} from "@/utils/type-vaildator";
import api from "./api";
import { HourlyGenerationStatsResponse } from "./agent-v2-user-stats-hourly-generation";

// 原始接口
export interface TrendGenerationStatsResponse {
  date: Date;
  items: Array<Items>;
};

export interface Items {
  date: string;
  active_users: number;
  total_product: number;
};


export class TrendStatsItemsData {
  @Required("Date cannot be empty")
  @IsString("Date must be a string")
  date: string;

  @Required("Hour cannot be empty")
  @IsNumber("Hour must be a number")
  activeUsers: number;

  @Required("Count cannot be empty")
  @IsNumber("Count must be a number")
  totalProduct: number;
}

export class TrendGenerationStatsData {
  @Required("items cannot be empty")
  @IsArray("items must be an array")
  items: TrendStatsItemsData[];
}

const transformAndValidateAgent = (
  response: TrendGenerationStatsResponse
): TrendGenerationStatsData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, TrendGenerationStatsData);
  } catch (error) {
    console.error("Agent User Trend Generation Stats data validation failed:", error.message);
    throw error;
  }
};

/** 内容管理 - 生成趋势 */
export const trendGenerationStats = async ({
  recentDays,
  agentId,
}: { recentDays: number, agentId: string }): Promise<TrendGenerationStatsData> => {
  const response = await api.post<TrendGenerationStatsResponse>('/agent-v2/user-stats/trend', {
    recent_days: recentDays,
    agent_id: agentId,
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
